import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import styled from 'styled-components'
import { autobind } from 'react-decoration'
import { Button } from '@components/input'
import TextField from '@components/textField'

import { actions } from 'mindself-api-client'
const { UserActions } = actions

const Title = styled.h1`
  font-size: 36px;
  color: rgba(0, 0, 0, 0.56);
  margin: 0;
  padding-bottom: 16px;
  font-weight: normal;
`

const Text = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  margin-top: 16px;

  & > a {
    color: #4a90e2;
    cursor: pointer;
  }
`

@connect(null, UserActions)
class Register extends Component {
  state = {
    email: '',
    username: '',
    password: '',
  }
  @autobind
  handleChange(field) {
    return value => {
      this.setState(() => ({ [field]: value }))
    }
  }
  @autobind
  async handleSubmit() {
    const { email, username, password } = this.state
    const { requestRegister, register } = this.props
    await requestRegister('email', email)
    const verify =
      '4700000000000000a960714480fb5588c751e60b146f2816313062d0d207ff55ea5a75cac1a29aff'
    const res = await register(verify, username, password)
    console.log(res)
  }
  render() {
    const { className } = this.props
    const { email, username, password } = this.state
    return (
      <div className={cn(className, 'login-page')}>
        <img src="./assets/Mindself_logo.png" alt="logo" width="80px" />
        <Title>Sign Up Mindself</Title>
        <div className="text-field">
          <TextField
            title="EMAIL"
            value={email}
            onChange={this.handleChange('email')}
          />
        </div>
        <div className="text-field">
          <TextField
            title="USERNAME"
            value={username}
            onChange={this.handleChange('username')}
          />
        </div>
        <div className="text-field">
          <TextField
            password
            title="PASSWORD"
            value={password}
            onChange={this.handleChange('password')}
          />
        </div>
        <div className="button">
          <Button primary text="Sign Up" onClick={this.handleSubmit} />
        </div>
        <Text>
          By clicking Sign Up, you agree to our <a>Term of Service</a> and{' '}
          <a>Privacy Policy</a>
        </Text>
        <Text>
          Have an account? <a>Log in</a>
        </Text>
      </div>
    )
  }
}

export default styled(Register)`
  &.login-page {
    padding-top: 96px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 360px;
    margin: 0 auto;
  }

  & > img {
    border-radius: 50%;
    margin-bottom: 32.8px;
  }

  & > .text-field {
    margin-top: 16px;
    width: 100%;
  }

  & > .button {
    margin: 32px 0 8px;
    width: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/pages/register.js